import { render, staticRenderFns } from "./SilentboxMediaGallery.vue?vue&type=template&id=2c761b6c&scoped=true"
import script from "./SilentboxMediaGallery.vue?vue&type=script&lang=ts"
export * from "./SilentboxMediaGallery.vue?vue&type=script&lang=ts"
import style0 from "./SilentboxMediaGallery.vue?vue&type=style&index=0&id=2c761b6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c761b6c",
  null
  
)

export default component.exports